export interface ISelectedRange {
  startDate: Date | null;
  endDate: Date | null;
}

export interface ISelectedSingleDate {
  date: Date | null;
}
